import React from 'react';
import { useTranslation } from 'react-i18next';

function BtnSelectAll({ handleSelectAll, isSelectAll, isDisabled, isProductArchived }) {
  const { t } = useTranslation('common');

  return (
    <button
      onClick={handleSelectAll}
      disabled={isDisabled || isProductArchived}
      aria-label="Select All"
      type={t('BTN_FILTER.BUTTON')}
      className="filter-btn filter-button_selectall px-1"
    >
      <i className="icon-check f-24" />
      {isSelectAll ? t('BTN_FILTER.UNSELECT_ALL') : t('BTN_FILTER.SELECT_ALL')}
    </button>
  );
}

export default BtnSelectAll;
